import React from "react";
import styles from "../../../Styles/Register.module.css";
import { RegisterForm } from "./Form";
import logo from '../../../Assets/logo/logo.svg'

function Register() {
  return (
    <div className={styles.register}>
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <div className={styles.content_left_wrapper}>
            <div className={styles.content_left}>
              <div className={styles.logo_wrapper}>
                <img src={logo} alt="logo" />
                <p className={styles.agent_pro}>Agent Pro</p>
              </div>
            </div>
          </div>
          <div className={styles.content_right_wrapper}>
            <div className={styles.content_right}>
              <p className={styles.welcome_back}>
                Welcome! Register to transform your business.
              </p>
              <div className={styles.input_details}>
                <RegisterForm sign_in={"sign in"} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles}></div>
    </div>
  );
}

export default Register;
